const STORAGE_KEY = 'welyb.embedded-client'
const EMBEDDED_VALUES = ['mobileapp', 'genericmobileapp', 'true']

const embeddedValueFrom = value => (EMBEDDED_VALUES.includes(value) ? value : null)

/**
 * `embedded` URL parameter (`?embedded=mobileapp`), possibly carried by the `redirect` parameter of the autologin
 * route, which is how the mobile app opens the parts of the webapp it embeds in a webview.
 */
export const detectEmbeddedClient = search => {
	const params = new URLSearchParams(search ?? '')
	const direct = embeddedValueFrom(params.get('embedded'))
	if (direct) {
		return direct
	}

	const redirect = params.get('redirect')
	if (redirect) {
		let decodedRedirect = redirect
		try {
			decodedRedirect = decodeURIComponent(redirect)
		} catch (error) {
			// A redirect that cannot be decoded is searched as it is.
		}
		return embeddedValueFrom(new URLSearchParams(decodedRedirect.split('?').pop()).get('embedded'))
	}
	return null
}

/**
 * Embedding mode of this page (`mobileapp`, `genericmobileapp`, `true`), or null for the webapp opened by itself.
 * Kept for the session of the webview: the URL parameter is lost as soon as the webapp navigates.
 */
export const getEmbeddedClient = (search = window.location.search, storage = window.sessionStorage) => {
	const detected = detectEmbeddedClient(search)
	try {
		if (detected) {
			storage.setItem(STORAGE_KEY, detected)
			return detected
		}
		return embeddedValueFrom(storage.getItem(STORAGE_KEY))
	} catch (error) {
		return detected
	}
}

export const isEmbeddedInMobileApp = (embeddedClient = getEmbeddedClient()) => ['mobileapp', 'genericmobileapp'].includes(embeddedClient)
